module.exports = __webpack_public_path__ + "img/layers-third.49c7db82.svg";